import { AutoFillIcon, BackIcon } from 'assets/icons';
import { Button, If } from 'components';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { VoidFn } from 'types/baseTypes';
import { resetCreateJobState } from '../createJobSlice';
import { useAppDispatch } from 'hooks';
import { CreateJobButtonIds } from 'containers/jobs/constant';
import { ButtonType } from 'components/custom-button/CustomButton';

interface CreateEditJobHeaderProps {
  isEdit: boolean;
  onCreate: VoidFn;
  onAutoFill: VoidFn;
  isActionInProgress: boolean;
}

const CreateEditJobHeader: FC<CreateEditJobHeaderProps> = ({ isEdit, onCreate, onAutoFill, isActionInProgress }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onBackClick = () => {
    navigate(-1);
    dispatch(resetCreateJobState());
  };

  return (
    <div className="flex w-full items-center justify-between border-b border-borderGray py-2.5 px-[30px]">
      <div className="flex items-center gap-5">
        <BackIcon
          className="cursor-pointer border-none outline-none"
          onClick={onBackClick}
          id={CreateJobButtonIds.CREATE_BACK_BUTTON}
          tabIndex={0}
          width={18}
          height={18}
        />
        <div className="text-xl font-bold text-primaryText">{isEdit ? 'Edit' : 'New'} job</div>
      </div>
      <div className="flex gap-6">
        <If condition={!isEdit}>
          <Button
            id={CreateJobButtonIds.AUTO_FILL_BUTTON}
            className="h-10 w-full cursor-pointer px-3"
            onClick={onAutoFill}
            type={ButtonType.SECONDARY}>
            <div className="flex items-center gap-1">
              <AutoFillIcon />
              Autofill with AI
            </div>
          </Button>
        </If>
        <Button
          id={CreateJobButtonIds.CREATE_BUTTON}
          className="h-10 w-[84px] cursor-pointer px-5"
          onClick={onCreate}
          isLoading={isActionInProgress}>
          {isEdit ? 'Save' : 'Create'}
        </Button>
      </div>
    </div>
  );
};

export default CreateEditJobHeader;
